import React from "react";

import "./available-voucher-modal-style.scss";

import BasicModal from "@src/componentsNew/Modals/BasicModal/BasicModal";
import Typography from "@src/componentsNew/Typography/Typography";

import { product_product, product_product_variants, product_product_availableVouchers } from "@components/ProductPage/ProductDetailPage/__generated__/product";
import {
  getPriceInfoFromProduct,
  getPriceInfoFromVariant,
  formatPrice
} from "@src/utils";

interface IProps {
  product: product_product;
  selectedVariant: product_product_variants | null;
  open: boolean;
  onClose: () => void;
}

const AvailableVoucherModal = ({ product, selectedVariant, open, onClose }: IProps) => {
  const calcVoucherPrice = (availableVoucher: product_product_availableVouchers) => {
    if (availableVoucher.discountValueType === 'PERCENTAGE') {
      if (selectedVariant) {
        return getPriceInfoFromVariant(selectedVariant).finalPrice * availableVoucher.discountValue / 100
      } else {
        return getPriceInfoFromProduct(product).finalPrice * availableVoucher.discountValue / 100;
      }
    } else if (availableVoucher.discountValueType === 'FIXED') {
      if (selectedVariant) {
        return getPriceInfoFromVariant(selectedVariant).finalPrice - availableVoucher.discountValue;
      } else {
        return getPriceInfoFromProduct(product).finalPrice - availableVoucher.discountValue;
      }
    }
  };

  return (
    <BasicModal
      modalId="mobile-detail-voucher-modal"
      title="Available Vouchers"
      titleColor="#000000DE"
      content={
        <>
          {
            product.availableVouchers
              .sort((a, b) => calcVoucherPrice(b) - calcVoucherPrice(a))
              .map((availableVoucher, idx) =>
                <div key={availableVoucher.id} className={`voucher-modal-content ${idx === 0 ? 'first' : ''} ${idx === product.availableVouchers.length - 1 ? 'last' : ''}`}>
                  <Typography cName="voucher-modal-text" variant="body3" component="span" style={{ color: "#666666" }}>
                    {availableVoucher.name}
                  </Typography>

                  <Typography cName="voucher-modal-price" variant="subtitle2" component="span" style={{ color: "#212121" }}>
                    {`- ${formatPrice(calcVoucherPrice(availableVoucher))}`}
                  </Typography>
                </div>
              )
          }
        </>
      }
      contentColor="#666666"
      open={open}
      onClose={onClose}
      closeButtonText="Close"
      showCloseIcon={false}
    />
  )
}

export default AvailableVoucherModal;
